import React from 'react';
import { CardContent } from "@/components/ui/card";
import GlowCard from "@/components/GlowCard";
import OptimizedImage from "@/components/OptimizedImage";
import { SimpleReveal } from "@/hooks/useSimpleAnimation";
interface TechnologyCardProps {
  title: string;
  description: string;
  image: string;
  isActive?: boolean;
  isMobile?: boolean;
  onClick?: () => void;
  delay?: number;
}
const TechnologyCard = ({
  title,
  description,
  image,
  isActive = true,
  isMobile = false,
  onClick,
  delay = 0
}: TechnologyCardProps) => {
  const content = (
    <div onClick={onClick} className={`h-full ${onClick ? "cursor-pointer" : ""}`}>
      <GlowCard rounded="lg" className="h-full flex flex-col">
        <div className="relative h-40 md:h-52 lg:h-60 overflow-hidden rounded-t-lg flex-shrink-0">
          <OptimizedImage src={image} alt={title} className="w-full h-full object-cover object-top transition-transform duration-500 ease-out hover:scale-[1.03]" sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw" />
        </div>
        <CardContent className={`px-4 py-4 md:px-5 md:py-5 flex flex-col flex-1 ${isMobile ? 'justify-center items-center text-center min-h-[140px]' : 'justify-start'}`}>
          <h3 className={`text-card-title mb-2 md:mb-3 ${isMobile ? 'text-center' : ''}`}>
            {title}
          </h3>
          <p className={`text-body leading-relaxed ${isMobile ? 'text-center max-w-prose' : 'text-left'}`}>
            {description}
          </p>
        </CardContent>
      </GlowCard>
    </div>
  );

  return isMobile ? content : <SimpleReveal delay={delay}>{content}</SimpleReveal>;
};
TechnologyCard.displayName = 'TechnologyCard';
export default React.memo(TechnologyCard);